import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared-components/user/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HelpMenuModalComponent } from '../help-menu-modal/help-menu-modal.component';
import * as _ from 'lodash';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'app-settings-menu-modal',
    templateUrl: './settings-menu-modal.component.html',
    styleUrls: ['./settings-menu-modal.component.css']
})
export class SettingsMenuModalComponent implements OnInit {
    cards: any[] = [];
    districtCards: any[] = []; // Cards that the user can not reorder or control the display of
    loginSettings: LoginSettings;
    constructor(
        private dialog: MatDialog,
        private userService: UserService,
        private loginService: LoginService,
        private matDialogRef: MatDialogRef<SettingsMenuModalComponent>
    ) {
        this.loginSettings = this.loginService.LoginSettings;
    }

    ngOnInit() {
        // We need a deep copy of the object so there are no live updates
        this.cards = _.cloneDeep(this.userService.cards);
        this.initialSort();
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.cards, event.previousIndex, event.currentIndex);
        // re-index the card positions
        for (let i = 0; i < this.cards.length; i++) {
            this.cards[i].position = i;
        }
        // check all the card positions relative to the column break
        const colBreakIndex = this.cards.findIndex(c => c.title == 'Column Break');
        for (let i = 0; i < this.cards.length; i++) {
            if (i < colBreakIndex) {
                this.cards[i].columnPosition = 'L';
            }
            if (i > colBreakIndex) {
                this.cards[i].columnPosition = 'R';
            }
        }
    }

    helpClick() {
        this.dialog.open(HelpMenuModalComponent, { disableClose: true, autoFocus: false, minWidth: '90vw', minHeight: '90vh' });
    }

    initialSort() {
        // Remove staff only cards
        if (this.userService.userType != 1) {
            this.cards = this.cards.filter(card => !card.staffOnly);
        }
        // separate the cards based on column
        this.districtCards = this.cards.filter(card => card.showInSettings == false);
        this.cards = this.cards.filter(card => card.showInSettings == true);
        let cardsLeft = this.cards.filter(card => card.columnPosition == 'L');
        let cardsRight = this.cards.filter(card => card.columnPosition == 'R');
        // Sort each set
        cardsLeft = cardsLeft.sort(function (a, b) {
            if (a.position < b.position) {
                return -1;
            }
            if (a.position > b.position) {
                return 1;
            }
        });
        cardsRight = cardsRight.sort(function (a, b) {
            if (a.position < b.position) {
                return -1;
            }
            if (a.position > b.position) {
                return 1;
            }
        });
        // clear the initial array, pass in all the cards
        this.cards = [];
        for (let i = 0; i < cardsLeft.length; i++) {
            this.cards.push(cardsLeft[i]);
        }
        // Add the column break
        this.cards.push({ title: 'Column Break' });
        for (let i = 0; i < cardsRight.length; i++) {
            this.cards.push(cardsRight[i]);
        }
    }

    checkColumnName(card) {
        if (card.title == 'Column Break' || card.title == '') {
            return false;
        } else {
            return true;
        }
    }

    showDetailedOption(card) {
        if (card.hasDetailCard) {
            if (card.title == 'Attendance' && this.loginSettings.ViewDailyAttendance)
                return false
            else
                return true;
        }
        return false;
    }

    selectionChanged(card, event) {
        card.display = event.value;
    }

    cancelClick() {
        this.matDialogRef.close('Canceled');
    }

    saveClick() {
        this.districtCards.forEach((card) => {
            this.cards.push(card);
        });
        this.userService.cards = this.cards;
        this.matDialogRef.close('Saved');
    }

}
